export default __webpack_public_path__ + "static/media/most-popular-artwork-1.b923c69c.png";